<template>
    <main class="automatic-home">
        <section v-if="data.categories.length" class="automatic-categories-section">
            <div class="container">
                <div class="automatic-section-heading">
                    <div>
                        <h2>{{ data.categoriesTitle }}</h2>
                        <p>{{ data.categoriesSubtitle }}</p>
                    </div>
                    <a :href="data.categoriesUrl" class="automatic-view-all">
                        {{ data.viewAll }} <i class="las la-angle-left" aria-hidden="true"></i>
                    </a>
                </div>

                <div class="automatic-categories" role="list">
                    <a v-for="category in data.categories" :key="category.id" :href="category.url"
                        class="automatic-category" role="listitem">
                        <span class="automatic-category-image">
                            <img v-if="category.hasLogo" :src="category.logo" :alt="category.name"
                                loading="lazy" width="76" height="76" />
                            <i v-else class="las" :class="category.icon" aria-hidden="true"></i>
                        </span>
                        <strong>{{ category.name }}</strong>
                    </a>
                </div>
            </div>
        </section>

        <section v-for="section in data.sections" :key="section.key"
            class="automatic-product-section" :aria-labelledby="`automatic-${section.key}`">
            <div class="container">
                <div class="automatic-section-heading">
                    <div class="automatic-section-title">
                        <span class="automatic-section-icon"><i :class="section.icon" aria-hidden="true"></i></span>
                        <div>
                            <h2 :id="`automatic-${section.key}`">{{ section.title }}</h2>
                            <p>{{ section.subtitle }}</p>
                        </div>
                    </div>
                    <a :href="section.url" class="automatic-view-all">
                        {{ data.viewAll }} <i class="las la-angle-left" aria-hidden="true"></i>
                    </a>
                </div>

                <div class="automatic-products">
                    <div v-for="product in section.products" :key="product.id" class="automatic-product">
                        <product-card :product="product"></product-card>
                    </div>
                </div>

                <div v-if="section.key === 'daily-picks'" class="automatic-daily-note">
                    <i class="las la-sync" aria-hidden="true"></i> {{ data.refreshedDaily }}
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import ProductCard from "../ProductCard.vue";

export default {
    components: { ProductCard },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

};
</script>
